/* src/app/components/pages/about-us/about-us.component.scss */
.width-responsive {
  width: 50%;
  line-height: 28px;
}
@media (min-width: 928px) and (max-width: 1140px) {
  .width-responsive {
    width: 63%;
  }
  .width-responsive .p2 {
    line-height: 28px;
  }
}
@media (min-width: 603px) and (max-width: 928px) {
  .width-responsive {
    width: 80%;
  }
  .width-responsive .p1 {
    font-size: 24px;
  }
  .width-responsive .p2 {
    font-size: 16px;
    line-height: 20px;
  }
}
@media (min-width: 200px) and (max-width: 603px) {
  .width-responsive {
    width: 100%;
  }
  .width-responsive .p1 {
    font-size: 18px;
  }
  .width-responsive .p2 {
    font-size: 12px;
    line-height: 20px;
  }
}
.img-hover {
  overflow: hidden;
}
.img-hover img {
  transition: 0.5s all ease-in-out;
  cursor: pointer;
}
.img-hover:hover img {
  transform: scale(1.1);
}
::ng-deep .mat-accordion .mat-expansion-panel-spacing {
  margin: 0px !important;
}
/*# sourceMappingURL=about-us.component.css.map */
